import { createContext, useContext, useEffect, useState } from "react";
import { getUser, handleLogout } from "../api/auth";
import { log } from "../utils/log_utils";
import { removeUserCache } from "../utils/client_storage_utils";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [user, setUser] =  useState();

  const logout = async () => {
    setUser(null)
    removeUserCache()
    await handleLogout()
  }

  useEffect(() => {
    const handleForceLogout = () => {
      setUser(null);
      removeUserCache();
    };
    window.addEventListener('force-logout', handleForceLogout);
    return () => window.removeEventListener('force-logout', handleForceLogout);
  }, []);

  useEffect(()=>{

    async function loadUser (){
        setLoading(true)
        try {
          const {success, resp } = await getUser()
          log('loadUser in useEffect',resp,'auth-context')
          if(success){
            setUser(resp)
          }else{
            setError(resp)
            if(resp?.toLowerCase() === "invalid user identity"){
              setUser(null)
              removeUserCache()
            }
          }
        } catch (error) {
          setError(error)
          logout()
        } finally{
          setLoading(false)
        }
    }
    loadUser()
  },[setUser, setLoading, setError])

  

  return (
    <AuthContext.Provider value={{ user, setUser, loading, setLoading, error, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
